export default __webpack_public_path__ + "static/media/cny-box.177a45fa.webp";